import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import DishForm from 'stores/Forms/DishForm/DishForm';
import style from './BaseSpecifications.module.scss';
import { SpecificationType } from 'stores/Menu/types';
import { FormControl } from 'components/Form/FormControl/FormControl';
import SelectField from 'components/Form/Fields/Select/SelectField';

@observer
class Additives extends Component<{
  form: DishForm;
}> {
  render() {
    const { form } = this.props;
    const { baseSpecifications } = form!;
    if (!baseSpecifications || !baseSpecifications.length) {
      return null;
    }

    return baseSpecifications?.map?.(baseSpecification => {
      if (baseSpecification.name === SpecificationType.ADDITIVES) {
        const options =
          form.baseSpecificationsValues.find(
            v => v.specId === baseSpecification.id,
          )?.values ?? [];

        return (
          <div className={style.form__group} key={baseSpecification.id}>
            <h3 className={style.group__title}>
              <FormattedMessage id={baseSpecification.name} />
            </h3>
            <FormControl
              form={form}
              name="itemSpecs"
              render={props => (
                <SelectField
                  {...props}
                  isMulti
                  options={options}
                  onChange={v => form.updateSpecs(baseSpecification.id, v)}
                />
              )}
            />
          </div>
        );
      }
    });
  }
}

export default Additives;
